import GraphicPackingFiltersForm from './graphic-packing-filters-form';
import GraphicPackingEditForm from './graphic-packing-edit-form';

const GraphicPackingForms = {
    Filter: GraphicPackingFiltersForm,
    Edit: GraphicPackingEditForm,
};

export default GraphicPackingForms;